import React from 'react';
import CreatePasswordForm from 'components/structure/ForgotPassword/CreatePasswordForm';
import Logo from 'assets/Logo';

function CreatePassword() {
  return (
    <div className="flex min-h-screen flex-col justify-center overflow-hidden sm:py-12 publicBackgroundImage">
      <div className="relative bg-primary2 px-6 pt-10 pb-8 w-full shadow-xl sm:mx-auto max-w-[460px] sm:rounded-lg sm:px-10 rounded">
        <div className="absolute top-10 left-1/2 transform -translate-x-1/2">
          <Logo />
        </div>
        <div className="mx-auto max-w-md">
          <div className="pt-20 text-center leading-7">
            <h1>Welcome!</h1>
            <CreatePasswordForm />
          </div>
          <div className="pt-10 text-center text-neutral5 leading-4">
            ©2024 B-Line Technologies Inc. All rights reserved.
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreatePassword;
